export default "__VITE_ASSET__b37f7b0d__"